import React from 'react';
import styled from 'styled-components';

const CalendlyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background-color: #f9f9f9;
`;

const CalendlyHeading = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
`;

const CalendlyLink = styled.a`
  background-color: #01d47c;
  color: white;
  padding: 1rem 2rem;
  border-radius: 5px;
  font-size: 1.2rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(7, 197, 80, 0.671);
    transform: translateY(-2px);
  }
`;

export const ContactUs = () => {
  return (
    <CalendlyContainer id="contact">
      <CalendlyHeading>Schedule a Call</CalendlyHeading>
      <CalendlyLink
        href=""
        onClick={(e) => {
          e.preventDefault();
          window.Calendly.initPopupWidget({
            url: 'https://calendly.com/minutegrowth/30-minute-meeting-with-minute-team'
          });
        }}
      >
        Schedule time with me
      </CalendlyLink>
    </CalendlyContainer>
  );
};

export default ContactUs;